import React, { ComponentProps, memo } from 'react';
import { Select } from '@chakra-ui/react';
import { Label } from 'components';

import * as Styles from './styles';
import { TIconName } from 'components/Icon';
import { IIcon } from 'components/Icon/icons';

interface IOption {
  [key: string]: any;
}

interface IProps extends ComponentProps<typeof Select> {
  selectRef?: React.RefObject<HTMLSelectElement>;
  options: IOption[];
  optionLabel?: string;
  optionValue?: string;
  tip?: string | JSX.Element;
  tipIconName?: TIconName;
  tipIconColor?: IIcon['$iconColor'];
}

const SelectFieldComponent: React.FC<IProps> = ({
  selectRef,
  placeholder = '',
  options,
  optionLabel = 'label',
  optionValue = 'value',
  tip,
  tipIconName,
  tipIconColor,
  ...props
}) => {
  return (
    <Styles.Container>
      {props.label && (
        <Label tip={tip} $iconColor={tipIconColor} iconName={tipIconName} htmlFor={props.label}>
          {props.label}
        </Label>
      )}

      <Select ref={selectRef} placeholder={placeholder} {...props}>
        {options.map(option => (
          <option value={option[optionValue]} key={`option-${option[optionValue]}`}>
            {option[optionLabel]}
          </option>
        ))}
      </Select>
    </Styles.Container>
  );
};

export const SelectField = memo(SelectFieldComponent);
